/**
 * @license
 * Copyright (c) 2014, 2019, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 */
"use strict";define('ojs/ojcore',["require","ojs/ojcore-base","ojs/ojcontext","ojs/ojconfig","ojs/ojlogger","ojs/ojresponsiveutils","ojs/ojthemeutils","ojs/ojtimerutils","ojs/ojtranslation"],function(o,s,e,t,i,j,n,r,l){return s.Logger=i,s.Context=e,s.Config=t,s.ResponsiveUtils=j,s.ThemeUtils=n,s.TimerUtils=r,s.Translations=l,s});
